const subAbas = [
  { label: 'Usuários', rota: '/fornecedor/adm/usuarios' },
  { label: 'Fornecedores', rota: '/fornecedor/adm/fornecedores' },
  { label: 'Acessos', rota: '/fornecedor/adm/acessos' },
  { label: 'Logs', rota: '/fornecedor/adm/logs' },
  /*  { label: 'Histórico de RT', rota: '/fornecedor/adm/historicodert' },*/
  /*{
    label: 'Histórico de Vinculações',
    rota: '/fornecedor/adm/historicodevinculacoes',
  },
*/
  /*{ label: 'Relatórios', rota: '/daf/adm/relatorios' },*/
];

export default subAbas;
